/**
 * Initial state
 */
const initialState = {
    submitting: false,
    failedAttempt: false,
    isLoggedIn: false,
    token: false,
    user: false,
    updatingUser: 0
};

/**
 * User reducer
 */
export default function (state = initialState, action) {

    const {type, payload} = action;
    switch (type) {
        case "USER_RESET":
            return initialState;
        /**
          * To notify for failed attempt
         */
        case "USER_LOGIN_RESET_ATTEMPT":
            return {
                ...state,
                failedAttempt: false
            };
        case "USER_LOGIN_SUBMITTING":
            return {
                ...state,
                submitting: true
            };
        case "USER_LOGIN_FAILED":
            return {
                ...state,
                failedAttempt: true,
                submitting: false
            };
        case 'USER_LOGIN_IN':
            return {
                ...state,
                isLoggedIn: true,
                failedAttempt: false,
                submitting: false
            };
        case 'USER_LOG_OUT':
            return initialState;


        //destroy
        case 'USER_DESTROY_SUCCESS':
            return {
                ...state
            };
        case 'USER_DESTROY_FAILURE':
            return {
                ...state
            };


        //restore
        case 'USER_RESTORE_SUCCESS':
            return {
                ...state
            };
        case 'USER_RESTORE_FAILURE':
            return {
                ...state
            };
        case 'USER_UPDATE_INPROGRESS':
            return {
                ...state,
                updatingUser: payload.id,
            };
        case 'USER_UPDATE_SUCCESS':
            return {
                ...state,
                updatingUser: 0
            };
        case 'USER_UPDATE_FAILURE':
            return {
                ...state,
                updatingUser: 0
            };


        case 'USER_CREATE_INPROGRESS':
            return {
                ...state,
                submitting: true
            };
        case 'USER_CREATE_SUCCESS':
            return {
                ...state,
                submitting: false
            };
        case 'USER_CREATE_FAILURE':
            return {
                ...state,
                submitting: false
            };


        case 'USER_ASSIMILATE_SUCCESS':
            return {
                ...state,
                updatingUser:0
            }
        case 'USER_ASSIMILATE_FAILURE':
            return {
                ...state,
                updatingUser:0
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/users.js